import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../../apis/axios";
import toast from "react-hot-toast";
import { getToken } from "../../utilities";

// categorydelete
// coupondelete
const useDelete = ({
    refreshUrl = '',
    url = '',
    onSuccess,
    onError,
    successToastMessage,
    errorToastMessage
}) => {
    const queryClient = useQueryClient()
    const setDataToServer = useMutation((data) => setUsers(data), {
        onError: (err) => {
            if (errorToastMessage) {
                toast.error(errorToastMessage);
            }
            onError?.(err)
        },
        onSuccess: (data) => {
            toast.success(successToastMessage)
            if (refreshUrl)
                queryClient.invalidateQueries([refreshUrl])
            onSuccess?.(data)
        }
    })
    const setUsers = async (getFormData) => {
        let fd = new FormData()
        for (var key in getFormData) {
            if (Array.isArray(getFormData[key]) || typeof getFormData[key] === 'object') {
                fd.append(key, JSON.stringify(getFormData[key]));
            } else {
                fd.append(key, getFormData[key]);
            }
        }
        const response = await axios({
            method: "POST",
            data: fd,
            url: `/${url}`,
            headers: { Authorization: getToken() ? `Bearer ${getToken()}` : '', }
        })
        return response.data
    }

    const handleDelete = (data) => {
        setDataToServer.mutate(data)
    }
    return { setDataToServer,handleDelete, isLoading: setDataToServer.isLoading }
}

export default useDelete